import {MasterVehicle} from "../model/masterVehicle";
export class CommonFirebaseHelper {

  static getVehicleFromDispatch(agency, dispatchData, vehicleId: string) {
    /**
     * if user's agency is defined
     */
    if (agency) {
      // console.log("dispatchData[vehicleId]",JSON.parse(dispatchData[vehicleId]))
     if(dispatchData[vehicleId]) return JSON.parse(dispatchData[vehicleId]);
      // return dispatchData[vehicleId];

    } else {
      var dispatchVehicle;
      /**
       *if user's agency information is not defined, iterate all agencies
       * @type {string[]}
       */
      let agenciesKeys = Object.keys(dispatchData);
      for (let i = 0; i < agenciesKeys.length; i++) {
        let key = agenciesKeys[i];
        dispatchVehicle = dispatchData[key]['dispatch'][vehicleId];
        if (dispatchVehicle) {
          return dispatchVehicle;
        }
      }
      return dispatchVehicle;
    }
  }

  /**
   * update vehicle's live information (Impure function)
   * @param vehicle
   * @param item
   */
  static updateVehiclesLiveStatus(vehicle: MasterVehicle, item: any) {
    if (item) {
      vehicle.isActive = this.isVehicleLive(item);
      vehicle.timeStamp = item.tS;
    }
  }

  private static isVehicleLive(item: any) {
    return item.cIn && item.sST;
  }
}
